import actionCreatorFactory from "typescript-fsa";
import { BettingUser } from "../../services/betting";

const actionCreator = actionCreatorFactory();

export const USER_LINK_LOAD = 'USER_LINK_LOAD';
export const userLinkLoad = actionCreator<string>(USER_LINK_LOAD);

export const USER_LINK_LOAD_USER_IMAGE = 'USER_LINK_LOAD_USER_IMAGE';
export const userLinkLoadUserImage = actionCreator<string>(USER_LINK_LOAD_USER_IMAGE);

export const USER_LINK_SET = 'USER_LINK_SET';
export const userLinkSet = actionCreator<BettingUser>(USER_LINK_SET);

export const USER_LINK_SET_USER_IMAGE = 'USER_LINK_SET_USER_IMAGE';
export const userLinkSetUserImage = actionCreator<{userId: string, imageId: string}>(USER_LINK_SET_USER_IMAGE);